module.exports = __webpack_public_path__ + "img/title3.bf11ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/title3.png
// module id = NiqM
// module chunks = 15